import Vue from 'vue';

export default Vue.component('ed-portal-info-section', {
  props: ['title', 'hasCheckBox', 'hasReviewSelect', 'courses'],
  data: () => {
    return {
      form: [],
      sectionId: null,
      editionMode: false
    }
  }
});


